class IOSNotchDetector {
  static notchScreenConfigs = [
    // { min, max, models }
    { min: 375, max: 812, models: ['iPhone X', 'iPhone XS', 'iPhone 11 Pro', 'iPhone 12 mini', 'iPhone 13 mini', 'iPhone 14 mini'] },
    { min: 390, max: 844, models: ['iPhone 12', 'iPhone 12 Pro', 'iPhone 13', 'iPhone 13 Pro', 'iPhone 14', 'iPhone 14 Pro'] },
    { min: 393, max: 852, models: ['iPhone 15', 'iPhone 15 Pro'] },
    { min: 430, max: 932, models: ['iPhone 15 Pro Max'] },
    { min: 428, max: 926, models: ['iPhone 12 Pro Max', 'iPhone 13 Pro Max', 'iPhone 14 Pro Max'] },
    { min: 414, max: 896, models: ['iPhone XR', 'iPhone XS Max', 'iPhone 11', 'iPhone 11 Pro Max'] },
    { min: 402, max: 874, models: ['iPhone 16', 'iPhone 16 Pro'] },
    { min: 440, max: 956, models: ['iPhone 16 Plus'] },  // 16 Plus
    { min: 442, max: 980, models: ['iPhone 16 Pro Max'] },  // 16 Pro Max
  ];
  
  static isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.platform) || 
             (/iOS|iPhone OS/.test(navigator.userAgent) && !window.MSStream);
  }
  
  static isNotchScreen() {
      if (!this.isIOS()) return false;
      
      console.log(window.screen, 'window.screen');
      const width = window.screen.width;
      const height = window.screen.height;
      const min = Math.min(width, height);
      const max = Math.max(width, height);

      console.log(min, 'min', max, 'max');
      let r = this.notchScreenConfigs.some(config => 
            min === config.min && max === config.max
        );
        if(r === false){
            if(height > 800){
                return true;
            }
        }
      return r
  }
  
  static isLargeNotchScreen() {
      // 判断是否是大尺寸刘海屏（宽度 >= 390）
      if (!this.isIOS()) return false;
      
      const width = window.screen.width;
      const height = window.screen.height;
      const min = Math.min(width, height);
      const max = Math.max(width, height);
      
      return this.notchScreenConfigs.some(config => 
          min === config.min && max === config.max && min >= 390
      );
  }
  
  static getScreenInfo() {
      const width = window.screen.width;
      const height = window.screen.height;
      const min = Math.min(width, height);
      const max = Math.max(width, height);
      const aspectRatio = max / min;
      
      return {
          width,
          height,
          minDimension: min,
          maxDimension: max,
          aspectRatio: aspectRatio.toFixed(2),
          isNotchScreen: this.isNotchScreen(),
          isLargeNotchScreen: this.isLargeNotchScreen()
      };
  }
}



export default IOSNotchDetector